export var RingBufferOverflow;
(function (RingBufferOverflow) {
    RingBufferOverflow[RingBufferOverflow["Throw"] = 0] = "Throw";
    RingBufferOverflow[RingBufferOverflow["Ignore"] = 1] = "Ignore";
})(RingBufferOverflow || (RingBufferOverflow = {}));
// this is a LastInFirstOut ringBuffer
export class RingBuffer {
    constructor(bufferSize = 10, overflow = RingBufferOverflow.Throw) {
        this.bufferSize = bufferSize;
        this.overflow = overflow;
        this.bufferStart = 0;
        this.bufferEnd = 0;
        this.isFull = false;
        this.buffer = new Array(this.bufferSize);
    }
    push(element) {
        if (Array.isArray(element)) {
            this.pushMultiple(element);
        }
        else {
            if (this.isFull) {
                if (this.overflow === RingBufferOverflow.Throw) {
                    throw new Error("Buffer overflow!");
                }
                // this.bufferStart = (this.bufferStart + 1) % this.bufferSize;
                if (++this.bufferStart >= this.bufferSize)
                    this.bufferStart = 0;
            }
            this.buffer[this.bufferEnd] = element;
            // this.bufferEnd = (this.bufferEnd + 1) % this.bufferSize;
            if (++this.bufferEnd >= this.bufferSize)
                this.bufferEnd = 0;
            this.isFull = this.bufferEnd === this.bufferStart;
        }
    }
    pushMultiple(elements) {
        for (const e of elements) {
            this.push(e);
        }
    }
    peek() {
        return this.buffer[this.bufferStart];
    }
    seek() {
        const newStart = (this.bufferStart + 1) % this.bufferSize;
        if (newStart !== this.bufferEnd) {
            this.bufferStart = newStart;
        }
    }
    pop() {
        if (this.bufferStart === this.bufferEnd)
            return undefined;
        this.isFull = false;
        const element = this.buffer[this.bufferStart];
        this.buffer[this.bufferStart] = undefined;
        if (++this.bufferStart >= this.bufferSize)
            this.bufferStart = 0;
        return element;
    }
    popMultiple(amount = 1) {
        if (amount < 1)
            return [];
        // we limit the extraction to what is in the buffer;
        const extractAmount = Math.min(amount, this.getBufferLength());
        this.isFull = false;
        const newStart = (this.bufferStart + extractAmount) % this.bufferSize;
        const tillEndCounter = Math.min(extractAmount, this.bufferSize - this.bufferStart);
        let tillEnd = this.buffer.slice(this.bufferStart, this.bufferStart + tillEndCounter);
        if (newStart < this.bufferStart) {
            // we wrapped around the end of the buffer, append the rest from the start of the buffer
            tillEnd = tillEnd.concat(this.buffer.slice(0, newStart));
        }
        for (let i = 0; i < tillEndCounter; ++i) {
            this.buffer[(i + this.bufferStart) % this.bufferSize] = undefined;
        }
        this.bufferStart = newStart;
        return tillEnd;
    }
    getBufferLength() {
        if (this.isFull)
            return this.bufferSize;
        let bufferLength = this.bufferEnd - this.bufferStart;
        if (bufferLength < 0) {
            bufferLength += this.bufferSize;
        }
        return bufferLength;
    }
    getFreeBufferLength() {
        return this.bufferSize - this.getBufferLength();
    }
    empty() {
        return this.getBufferLength() === 0;
    }
}
